import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Link } from '@change/ds-core-ui';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';
import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { getPetitionQRCode } from 'src/app/shared/api/qrcode';
import { useAsyncDownload } from 'src/app/shared/hooks/download';

export const PetitionQRCodeDownloadLink: React.FC<
	PropsWithChildren<{
		slugOrId: string;
		type: QrCodeType;
		size?: number;
		filename?: string;
		onClick?: () => Promise<void>;
	}>
> = ({ children, slugOrId, size, type, filename, onClick }) => {
	const utilityContext = useUtilityContext();

	const { actions } = useAsyncDownload({
		fetchData: async () => {
			const result = await getPetitionQRCode({
				slugOrId,
				type,
				size,
				utilityContext,
			});
			return { dataUri: result.imageBase64Uri };
		},
		filename: filename || 'petition-qrcode.png',
		onDownload: onClick,
	});

	return (
		<Link
			href="#"
			onClick={actions.handleDownload}
			bold
			size="small"
			variant="secondary"
			data-qa="qrcode-download-link"
			data-testid="qrcode-download-link"
			preventScrollReset
		>
			{children}
		</Link>
	);
};
